import type { OrgDraftByStarsSummaryItemResponse } from '@on3/api';
import { StarRating } from '@public/components/UI/StarRating/StarRating';
import { Text } from '@public/components/UI/Typography/Text';
import clsx from 'clsx';

import styles from './TeamDraftSummary.module.scss';

interface ITeamSummaryItemProps {
  stars?: OrgDraftByStarsSummaryItemResponse;
  starNum: number;
  orgName?: string | null;
  orgAbbrev?: string | null;
  totalDrafted?: number | null;
  draftRank?: number | null;
  mascot?: string | null;
}
const numberOfStars = {
  0: 0,
  1: 5,
  2: 4,
  3: 3,
};

export const TeamSummaryItem = ({
  stars,
  starNum,
  orgName,
  orgAbbrev,
  mascot,
}: ITeamSummaryItemProps) => {
  const { drafted } = stars || {};
  const starNumber = numberOfStars[starNum as keyof typeof numberOfStars];
  const teamName = orgName?.replace(`${mascot}`, '');

  return (
    <div className={styles.starItemWrapper}>
      <div
        className={clsx(styles.starItem, styles.starDraftedItem, {
          [styles.total]: starNumber === 0,
        })}
      >
        <Text
          className={clsx(styles.starsLabel, {
            [styles.total]: starNumber === 0,
          })}
          component="span"
        >
          {starNumber
            ? `${orgAbbrev} ${starNumber}-stars`
            : `${teamName} Total Players`}
        </Text>
        {!!starNumber && (
          <StarRating className={styles.starRating} stars={starNumber} />
        )}

        <Text className={styles.numDrafted} component="span" variant={'h1'}>
          <Text className={styles.desktopLabel} component="span" variant="h6">
            drafted
          </Text>
          {drafted ?? '-'}
        </Text>
      </div>
    </div>
  );
};
